import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';

export const careInboxUnreadKey = ['care-inbox-unread'] as const;

/**
 * Care-inbox threads with patient messages the clinic hasn't read, for the
 * sidebar badge. Zero when disabled or on any error: it's a hint, not data.
 */
export function useCareInboxUnreadCount(enabled: boolean): number {
  const query = useQuery({
    queryKey: careInboxUnreadKey,
    enabled,
    refetchInterval: 60_000,
    retry: false,
    queryFn: async () => {
      const res = await apiClient.get<{ success: boolean; data: { count: number } }>('/care-inbox/unread-count');
      return res.data?.count ?? 0;
    },
  });
  return query.data ?? 0;
}
